module.exports = "/_next/static/images/32a4a357eb7ce743b40d05632f064107-stapler@desktop1366.jpg";